import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { cnButton } from '../Button.cn';

import './Button-Text.css';

export type IButtonTextProps = PropsWithChildren<IClassNameProps>;

export const ButtonText: FC<IButtonTextProps> = ({ children, className, ...props }) => (
    <span {...props} className={cnButton('Text', null, [className])}>
        {children}
    </span>
);
